import { map, atom } from 'nanostores';

export interface Store {
    type?: Array<string>;
    topic?: string;
    sort: string;
}

export const type = atom<number|undefined>(undefined);
export const topic = atom<string|undefined>(undefined);
export const sort = atom<string>("latest");
export const excludes = map<Array<string>>([]);